export default "__VITE_ASSET__Bf1H9PZQ__"